var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCharmFlag = function SvgCharmFlag(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#FEFEFE",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2,
    d: "M2.188 17.813V4.063s2.5-1.875 5-1.875 3.125 1.874 5.625 1.874 5-1.875 5-1.875v8.75s-2.5 1.876-5 1.876-3.126-1.876-5.626-1.876-5 1.876-5 1.876"
  })));
};
export { SvgCharmFlag as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIuMTg3NSAxNy44MTI1VjQuMDYyNUMyLjE4NzUgNC4wNjI1IDQuNjg3NSAyLjE4NzUgNy4xODc1IDIuMTg3NUM5LjY4NzUgMi4xODc1IDEwLjMxMjUgNC4wNjI1IDEyLjgxMjUgNC4wNjI1QzE1LjMxMjUgNC4wNjI1IDE3LjgxMjUgMi4xODc1IDE3LjgxMjUgMi4xODc1VjEwLjkzNzVDMTcuODEyNSAxMC45Mzc1IDE1LjMxMjUgMTIuODEyNSAxMi44MTI1IDEyLjgxMjVDMTAuMzEyNSAxMi44MTI1IDkuNjg3NSAxMC45Mzc1IDcuMTg3NSAxMC45Mzc1QzQuNjg3NSAxMC45Mzc1IDIuMTg3NSAxMi44MTI1IDIuMTg3NSAxMi44MTI1IiBzdHJva2U9IiNGRUZFRkUiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+Cjwvc3ZnPgo=";